import Select from '../Select';
import FeatureGateMessage from '../FeatureGateMessage.jsx';
import { Link } from 'react-router-dom';
import { getBusinessUrl } from '~/lib/useBusinessNavigate.js';

export function getOptionsFromSchema(type, schema) {
    const options = {};
    for (const item of schema) {
        if (item.type === type) {
            options[`{${item.key}}`] = item.label;
        }
    }

    return options;
}

const SmsSettings = ({ settings, setSettings, schema }) => {
    const phoneOptions = getOptionsFromSchema('phone', schema);

    const eventMessages = [
        'Reminder, {event-type-name} is on {event-start}',
        'Reminder, {event-type-name} is on {event-start} with {booked-with}',
        'Reminder, {event-type-name} is on {event-start} at {location}',
        'Reminder, {event-type-name} is on {event-start}. Join meeting at {location}.',
        '{event-type-name} is booked with {booked-with} on {event-start}',
        'Confirmed: {event-type-name} is on {event-start}',
        'Confirmed: {event-type-name} is on {event-start} with {booked-with}',
        'Canceled: {event-type-name} on {event-start}',
        'Canceled: {event-type-name} on {event-start} with {booked-with}',
        'Rescheduled: {event-type-name} is now on {event-start}',
        'New booking for {booked-with}: {event-type-name} with {client-name} at {event-start}. View: {admin-url}',
        'Did you take attendance for {event-type-name} on {event-start}?',
        'New booking for {event-type-name}, view: {confirmation-url}',
    ];

    const packageMessages = [
        'Your package, {package-name} now has {amount-remaining}{package-type} remaining',
        '{package-name} has {amount-remaining}{package-type}',
        '{package-name} can be used for {amount-remaining}{package-type}',
    ];

    const invoiceMessages = [
        'Invoice #{invoice-id} for {invoice-total} is due on {invoice-due-at} {invoice-view-link}',
        'Reminder: Invoice #{invoice-id} for {invoice-total} is due on {invoice-due-at} {invoice-view-link}',
        'Thank you! Payment received for Invoice #{invoice-id}',
        'Invoice #{invoice-id} for {invoice-total} has been sent. View it here: {invoice-view-link}',
    ];

    const waitlistMessages = [
        '{waitlist-event-type-name} is available on {waitlist-datetime}, book now at {waitlist-signup-url}',
        'A spot for {waitlist-event-type-name} opened up on {waitlist-datetime}, book at {waitlist-signup-url}',
    ];

    const hasEvent = !!schema.find(s => s.key === 'event-type-name');
    const hasPackage = !!schema.find(s => s.key === 'package-type');
    const hasWaitlist = !!schema.find(s => s.key.indexOf('waitlist-') > -1);
    const hasInvoice = !!schema.find(s => s.key === 'invoice-total');

    const messages = [
        ...(hasEvent ? eventMessages : []),
        ...(hasPackage ? packageMessages : []),
        ...(hasWaitlist ? waitlistMessages : []),
        ...(hasInvoice ? invoiceMessages : []),
    ];

    const messageOptions = {};
    messages.forEach(m => (messageOptions[m] = m));

    // If message isn't in the list, add it
    if (settings?.message && !messageOptions[settings?.message]) {
        messageOptions[settings?.message] = settings?.message;
    }

    // If the 'to' isn't in the list, add it
    if (settings?.to && !phoneOptions[settings?.to]) {
        phoneOptions[settings?.to] = settings?.to;
    }

    return (
        <div className="mb-16">
            <Select
                label="To"
                value={settings?.to || ''}
                onChange={value => setSettings(old => ({ ...old, to: value }))}
                options={phoneOptions}
            />

            <Select
                label="Message"
                className="mt-4"
                inputClassName="max-w-full"
                value={settings?.message || ''}
                onChange={value =>
                    setSettings(old => ({ ...old, message: value }))
                }
                options={messageOptions}
            />

            <div className="text-sm text-gray-500 mt-1">
                This will only be sent to clients who opt-in to receiving texts.<br />
                Texts beyond your included message limit are charged at $0.035 per text. See <Link target="_blank" to={getBusinessUrl(`/settings/billing`)}>Billing</Link> for details.
            </div>
        </div>
    );
};

export default SmsSettings;
